import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getErrUploadApi } from "./errorApi";

export const getErrUploadRequest = createAsyncThunk(
  "getErrUploadRequest/error",
  async () => {
    try {
      const response = await getErrUploadApi();
      return response;
    } catch (error) {
      console.log(error);
    }
  }
);

interface IInitialState {
  uploadSheduleErrors: any[];
  pageIsLoading: boolean;
  message: string;
}

const initialState: IInitialState = {
  uploadSheduleErrors: [],
  pageIsLoading: false,
  message: "",
};

const errorSlice = createSlice({
  name: "error",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    // get err schedule upload reducer
    builder.addCase(getErrUploadRequest.pending, (state) => {
      state.pageIsLoading = true;
    });
    builder.addCase(getErrUploadRequest.fulfilled, (state, action) => {
      console.log(action);

      if (action.payload.status === 1000) {
        state.uploadSheduleErrors = action.payload.data;
        state.pageIsLoading = false;
      } else {
        state.message = "someting went wrong";
        state.pageIsLoading = false;
      }
    });
    builder.addCase(getErrUploadRequest.rejected, (state) => {
      state.message = "someting went wrong on server";
      state.pageIsLoading = false;
    });
  },
});

export const {} = errorSlice.actions;
export default errorSlice.reducer;
